<script setup>
import { onMounted, shallowRef, watch } from 'vue'
import { useApi } from '@provise/composables/api'
import SelectId from '@/components/select/selectIdObject.vue'
const model = defineModel()
const medicines = shallowRef([])
const medicinesQuery = shallowRef({})

const { refresh: fetchMedicines } = useApi({
  url: 'catalog/medicines',
  model: medicines,
  query: medicinesQuery,
  watch: [medicinesQuery],
  pick: d => (d.data || []).map(mapMedicine),
})
watch(
  model,
  async mv => {
    if (mv?.id) {
      await fetchMedicines()
    }
  },
  { immediate: true }
)
function mapMedicine(m) {
  return {
    ...m,
    label: `${m.name}, ${m.dosage}, ${m.medicine_trademark?.medicinal_form?.value}`,
  }
}
function onSearchMedicines(term) {
  if (!(term + '').length) {
    return
  }

  medicinesQuery.value = { search: term }
}

onMounted(async () => {
  await fetchMedicines()
})
</script>
<template>
  <SelectId
    :options="medicines"
    @search="onSearchMedicines"
    values="label"
    v-model="model"
    v-bind="$props"
  />
</template>
